import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const EditPencil = ({
  width = 24,
  height = 24,
  className,
  color = "primary",
  decorative = false,
  ariaLabel = "Edit",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M18.4 2.6a2.9 2.9 0 0 1 2.1.9 3 3 0 0 1 0 4.3L8.8 19.4l-5.2 1 1-5.2L16.2 3.5a3.1 3.1 0 0 1 2.2-.9m-2.9 3-.7.7 2.9 2.9.7-.7zm-1.4 1.5 1.1 1-8.4 8.4-1.1-1.1zM5.1 18a.7.7 0 0 1 .6.3.7.7 0 0 1 .3.6l1.5-.3-2.1-2.1zm3.5.3-1.1-1.1 8.4-8.4 1 1.1zM19.1 7.8l.7-.7a2.1 2.1 0 0 0 0-2.9 2 2 0 0 0-1.4-.6 2.2 2.2 0 0 0-1.5.6l-.7.7z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
